import { getTabStatus } from "../services/yourAssets/CommonServices";
import { getUserIdFromLocalStorage } from "./Utilities";

let suggestionBoxText = [];
let uID = getUserIdFromLocalStorage();
export const getSBText = async () => {
  let result = await getTabStatus(uID);

  let array = [];

  for (let i = 0; i < result?.payLoad?.length; i++) {
    const elementI = result?.payLoad[i];
    let obj = {
      id: 0,
      status: "",
      tabName: "",
      text: [],
    };
    obj.id = elementI.aboutStatusViewId;
    obj.status = elementI.isVisited;
    obj.tabName = elementI.sectionName;
    let htmlArray = [];

    for (let j = 0; j < elementI.aboutStatusHtmlText.length; j++) {
      const elementJ = elementI.aboutStatusHtmlText[j];
      let htmlObj = {
        __html: "",
      };
      htmlObj.__html = elementJ;
      htmlArray.push(htmlObj);
    }
    obj.text = htmlArray;
    array.push(obj);
  }
  suggestionBoxText = array;
  return suggestionBoxText;
};

export const updateSBText = async (id) => {
  let array = suggestionBoxText;
  for (let i = 0; i < array.length; i++) {
    const elementI = array[i];
    if (elementI.id === id) {
      elementI.status = !elementI.status;
    }
  }
  suggestionBoxText = array;
};
